import { ref, onBeforeUnmount, openBlock, createElementBlock, createElementVNode, Fragment, renderList, normalizeClass, toDisplayString, createCommentVNode, computed, unref, createBlock, withDirectives, vModelText } from 'vue';
import { F as registerMercureHook, q as glob, b as useConfigStore } from './prodsel.store-B-MQAyQE.mjs';
import 'pinia';
import { u as useDeveloperConsoleState } from './developerConsoleState-B9_P2zPY.mjs';

const _hoisted_1$1 = { class: "mercure-console" };
const _hoisted_2$1 = { class: "uk-list" };
const _hoisted_3$1 = ["uk-icon"];
const _hoisted_4$1 = ["onClick"];
const _hoisted_5$1 = ["uk-icon"];
const _hoisted_6$1 = ["value"];


var script$1 = {
  __name: 'MercureConsole',
  setup(__props) {

const mc = ref([]);

function addConsoleEntry(type, data, event, options) {
    mc.value.push({type: type, data: data, event: event , options: options});
}

const releaseMercureEventsDebugHook = registerMercureHook("debug", addConsoleEntry);
const mercure = glob("mercure");
const mercureDebugHook = mercure?.addHook("debug", addConsoleEntry);

onBeforeUnmount(() => {
  if (typeof releaseMercureEventsDebugHook === 'function') {
    releaseMercureEventsDebugHook();
  }
  if (mercure?.hooks?.debug === mercureDebugHook) {
    mercure.removeHook("debug");
  }
});

function log(item) {
  console.log(item);
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$1, [
    _cache[0] || (_cache[0] = createElementVNode("h4", { class: "console-title" }, "Mercure Console", -1 /* HOISTED */)),
    createElementVNode("ul", _hoisted_2$1, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(mc.value, (item, key) => {
        return (openBlock(), createElementBlock("li", { key: key }, [
          createElementVNode("span", {
            "uk-icon": (item.event.origin=='local')?'icon:upload':'icon:download'
          }, null, 8 /* PROPS */, _hoisted_3$1),
          createElementVNode("span", {
            onClick: $event => (log(item)),
            class: normalizeClass(["uk-badge button", item.type])
          }, toDisplayString(item.type), 11 /* TEXT, CLASS, PROPS */, _hoisted_4$1),
          (item.event.origin=='local')
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                "uk-icon": (item.event.success)?'icon:check':'icon:close'
              }, null, 8 /* PROPS */, _hoisted_5$1))
            : createCommentVNode("v-if", true),
          createElementVNode("input", {
            value: item.event.data.substring(0,50)
          }, null, 8 /* PROPS */, _hoisted_6$1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

};

script$1.__scopeId = "data-v-7b517278";
script$1.__file = "src/components/debug/MercureConsole.vue";

const _hoisted_1 = { class: "developer-console" };
const _hoisted_2 = {
  key: 0,
  class: "developer-dock"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
  key: 0,
  class: "developer-dock-menu"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  key: 2,
  class: "developer-panel"
};
const _hoisted_9 = { class: "developer-hint" };
const _hoisted_10 = { class: "developer-section" };
const _hoisted_11 = { class: "developer-actions" };
const _hoisted_12 = {
  key: 3,
  class: "developer-panel product-form-panel"
};
const _hoisted_13 = { class: "developer-hint" };
const _hoisted_14 = { class: "pf-tabs" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = {
  key: 0,
  class: "developer-section product-form-list"
};
const _hoisted_17 = { class: "product-form-key" };
const _hoisted_18 = { class: "product-form-value" };
const _hoisted_19 = {
  key: 1,
  class: "developer-section"
};
const _hoisted_20 = {
  key: 1,
  class: "developer-section"
};
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "product-form-value" };
const _hoisted_23 = { key: 1 };


var script = {
  __name: 'DeveloperConsole',
  setup(__props) {

const configStore = useConfigStore();

const mcshow = ref(false);
const mercureConsole = glob('mercureConsole', mcshow);
const devPanelShow = ref(false);
const productFormPanelShow = ref(false);
const devDockOpen = ref(false);
const xdebugSession = ref(typeof window.xdebug === 'string' ? window.xdebug : '');
const xdebugCurrent = ref(typeof window.xdebug === 'string' ? window.xdebug : '');
const { productSelectorList } = useDeveloperConsoleState();

const isDeveloperMode = computed(() => {
    return Boolean(import.meta.env.DEV || configStore.developerMode === true || configStore.debug === true);
});

function toggleMercureConsole() {
    mcshow.value = !mcshow.value;
    if (mcshow.value) {
        devPanelShow.value = false;
        productFormPanelShow.value = false;
    }
}

function toggleDeveloperPanel() {
    devPanelShow.value = !devPanelShow.value;
    if (devPanelShow.value) {
        mcshow.value = false;
        productFormPanelShow.value = false;
    }
}

const currentProductSelector = computed(() => {
    const list = productSelectorList.value?.value;
    if (!Array.isArray(list) || list.length === 0) return null;

    return list.find((psEl) => psEl?.active) || list[0] || null;
});

const currentProductSelectorFormEntries = computed(() => {
    const form = currentProductSelector.value?.ps?.status?.form;
    const entries = form && typeof form === 'object'
        ? Object.entries(form)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        : [];

    const productPid = currentProductSelector.value?.ps?.status?.product?.pid;
    if (productPid) {
        const hasPidInForm = entries.some(([key]) => key === 'pid');
        if (!hasPidInForm) {
            entries.push(['pid', productPid]);
        }
    }

    return entries.sort(([left], [right]) => left.localeCompare(right));
});

const productFormTab = ref('form'); // 'form' | 'schema'

const currentProductSelectorSchema = computed(() => {
    const schema = currentProductSelector.value?.schema;
    if (!schema) return null;
    return schema;
});

function toggleProductFormPanel() {
    productFormPanelShow.value = !productFormPanelShow.value;
    if (productFormPanelShow.value) {
        mcshow.value = false;
        devPanelShow.value = false;
    }
}

function formatProductSelectorValue(value) {
    if (Array.isArray(value)) {
        return value.length ? JSON.stringify(value, null, 2) : '[]';
    }

    if (value && typeof value === 'object') {
        return JSON.stringify(value, null, 2);
    }

    return String(value);
}

function toggleDevDock() {
    devDockOpen.value = !devDockOpen.value;
}

function setXdebugSession() {
    const value = String(xdebugSession.value || '').trim();
    if (value.length > 0) {
        window.xdebug = value;
        xdebugCurrent.value = value;
    } else {
        delete window.xdebug;
        xdebugCurrent.value = '';
    }
}

function clearXdebugSession() {
    xdebugSession.value = '';
    delete window.xdebug;
    xdebugCurrent.value = '';
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    (isDeveloperMode.value)
      ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createElementVNode("button", {
            class: "developer-dock-toggle",
            type: "button",
            onClick: toggleDevDock,
            title: devDockOpen.value ? 'Developer Dock schliessen' : 'Developer Dock oeffnen'
          }, " DEV ", 8 /* PROPS */, _hoisted_3),
          (devDockOpen.value)
            ? (openBlock(), createElementBlock("div", _hoisted_4, [
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(["developer-dock-item", unref(mercureConsole) && 'is-active']),
                  onClick: toggleMercureConsole,
                  title: unref(mercureConsole) ? 'Mercure Console schliessen' : 'Mercure Console oeffnen'
                }, " MC ", 10 /* CLASS, PROPS */, _hoisted_5),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(["developer-dock-item", devPanelShow.value && 'is-active']),
                  onClick: toggleDeveloperPanel,
                  title: devPanelShow.value ? 'Developer Panel schliessen' : 'Developer Panel oeffnen'
                }, " DP ", 10 /* CLASS, PROPS */, _hoisted_6),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass(["developer-dock-item", productFormPanelShow.value && 'is-active']),
                  onClick: toggleProductFormPanel,
                  title: productFormPanelShow.value ? 'Product Form Panel schliessen' : 'Product Form Panel oeffnen'
                }, " PF ", 10 /* CLASS, PROPS */, _hoisted_7)
              ]))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true),
    (unref(mercureConsole))
      ? (openBlock(), createBlock(script$1, { key: 1 }))
      : createCommentVNode("v-if", true),
    (devPanelShow.value)
      ? (openBlock(), createElementBlock("div", _hoisted_8, [
          _cache[5] || (_cache[5] = createElementVNode("h4", { class: "developer-panel-title" }, "Developer Panel", -1 /* HOISTED */)),
          _cache[6] || (_cache[6] = createElementVNode("label", {
            for: "xdebug-session",
            class: "developer-label"
          }, "Xdebug Session", -1 /* HOISTED */)),
          withDirectives(createElementVNode("input", {
            id: "xdebug-session",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((xdebugSession).value = $event)),
            type: "text",
            class: "developer-input",
            placeholder: "z. B. PHPSTORM"
          }, null, 512 /* NEED_PATCH */), [
            [vModelText, xdebugSession.value]
          ]),
          createElementVNode("div", { class: "developer-actions" }, [
            createElementVNode("button", {
              type: "button",
              class: "developer-button",
              onClick: setXdebugSession
            }, "Setzen"),
            createElementVNode("button", {
              type: "button",
              class: "developer-button secondary",
              onClick: clearXdebugSession
            }, "Loeschen")
          ]),
          createElementVNode("small", _hoisted_9, "Aktuell: " + toDisplayString(xdebugCurrent.value || 'nicht gesetzt'), 1 /* TEXT */),
          createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = createElementVNode("label", { class: "developer-label" }, "Vidge Debug Overlay", -1 /* HOISTED */)),
            createElementVNode("div", _hoisted_11, [
              createElementVNode("button", {
                type: "button",
                class: normalizeClass(["developer-button", { active: unref(configStore).vidgeDebugOverlay }]),
                onClick: _cache[1] || (_cache[1] = $event => (unref(configStore).vidgeDebugOverlay = !unref(configStore).vidgeDebugOverlay))
              }, toDisplayString(unref(configStore).vidgeDebugOverlay ? 'Aktiv (ausschalten)' : 'Inaktiv (einschalten)'), 3 /* TEXT, CLASS */)
            ])
          ])
        ]))
      : createCommentVNode("v-if", true),
    (productFormPanelShow.value)
      ? (openBlock(), createElementBlock("div", _hoisted_12, [
          _cache[9] || (_cache[9] = createElementVNode("h4", { class: "developer-panel-title" }, "ProductSelector", -1 /* HOISTED */)),
          createElementVNode("small", _hoisted_13, toDisplayString(currentProductSelector.value?.id || 'nicht verfuegbar'), 1 /* TEXT */),
          createElementVNode("div", _hoisted_14, [
            createElementVNode("button", {
              class: normalizeClass(["pf-tab", { 'pf-tab--active': productFormTab.value === 'form' }]),
              onClick: _cache[2] || (_cache[2] = $event => (productFormTab.value = 'form'))
            }, "Form", 2 /* CLASS */),
            createElementVNode("button", {
              class: normalizeClass(["pf-tab", { 'pf-tab--active': productFormTab.value === 'schema' }]),
              onClick: _cache[3] || (_cache[3] = $event => (productFormTab.value = 'schema'))
            }, "FK Schema", 2 /* CLASS */)
          ]),
          createCommentVNode(" Form values "),
          (productFormTab.value === 'form')
            ? (openBlock(), createElementBlock("div", _hoisted_15, [
                (currentProductSelectorFormEntries.value.length)
                  ? (openBlock(), createElementBlock("div", _hoisted_16, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(currentProductSelectorFormEntries.value, ([key, value]) => {
                        return (openBlock(), createElementBlock("div", {
                          key: key,
                          class: "product-form-item"
                        }, [
                          createElementVNode("div", _hoisted_17, toDisplayString(key), 1 /* TEXT */),
                          createElementVNode("pre", _hoisted_18, toDisplayString(formatProductSelectorValue(value)), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (openBlock(), createElementBlock("div", _hoisted_19, _cache[7] || (_cache[7] = [
                      createElementVNode("small", { class: "developer-hint" }, "Keine gesetzten Selektoren gefunden.", -1 /* HOISTED */)
                    ])))
              ]))
            : createCommentVNode("v-if", true),
          createCommentVNode(" FK Schema "),
          (productFormTab.value === 'schema')
            ? (openBlock(), createElementBlock("div", _hoisted_20, [
                (currentProductSelectorSchema.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_21, [
                      createElementVNode("pre", _hoisted_22, toDisplayString(JSON.stringify(currentProductSelectorSchema.value, null, 2)), 1 /* TEXT */)
                    ]))
                  : (openBlock(), createElementBlock("div", _hoisted_23, _cache[8] || (_cache[8] = [
                      createElementVNode("small", { class: "developer-hint" }, "Kein Schema verfuegbar (noch kein Produkt geladen).", -1 /* HOISTED */)
                    ])))
              ]))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
}

};

script.__scopeId = "data-v-7eeb0c19";
script.__file = "src/components/debug/DeveloperConsole.vue";

export { script as a, script$1 as s };
